import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { i18n } from "../../translate/i18n";


export function StatusFilter({ onFiltered, initialSelectedStatus = [] }) {
  const [selecteds, setSelecteds] = useState(initialSelectedStatus);

  useEffect(() => {
    async function fetchData() {
      
    }
    fetchData();
  }, []);

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  const status = [
    { status: 'open', name: `${i18n.t("tickets.search.filterConectionsOptions.open")}`, color: '#2e7d32' },
    { status: 'closed', name: `${i18n.t("tickets.search.filterConectionsOptions.closed")}`, color: '#6b6b6b' },
    { status: 'pending', name: `${i18n.t("tickets.search.filterConectionsOptions.pending")}`, color: '#ff9800' },
    { status: 'archived', name: `${i18n.t("tickets.search.filterConectionsOptions.archived")}`, color: '#0277bd' },
    { status: 'group', name: 'Grupos', color: '#9c27b0' },

  ]

  return (
    <Box style={{ padding: "2px 10px" }}>
      <Autocomplete 
       multiple      
       size="medium"
       options={status || []}
       value={selecteds || []}
       onChange={(e, v, r) => onChange(v)}
       getOptionLabel={(option) => option?.name || ""}
        ListboxProps={{
          style: { 
            maxHeight: '200px', // Altura para mostrar mais opções
            overflow: 'auto', // Permitir scroll se houver mais opções
            padding: '8px 0', // Padding interno para melhor espaçamento
            borderRadius: '4px', // Bordas arredondadas
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)' // Sombra sutil
          }
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: option?.color || "#eee",
                textShadow: "1px 1px 1px #000",
                color: "white",
                height: "20px",
                fontSize: "11px"
              }}
              label={option?.name || ""}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
       renderInput={(params) => (
         <TextField
           {...params}
           variant="outlined"
           placeholder="Filtro por Status"
           size="medium"
           style={{ 
             marginBottom: "4px",
             minWidth: "250px",
             width: "100%"
           }}
           InputProps={{
             ...params.InputProps,
             style: {
               fontSize: "14px",
               padding: "8px 12px"
             }
           }}
         />
       )}
      />
    </Box>
  );
}
